// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"6bb4c05e","189":"05a373c1","202":"cbb0db52","217":"a935d619","223":"3e97457e","329":"556784e7","422":"d4553934","983":"c0daa952"}[chunkId] + ".chunk.js";
};